module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAIklEQVR4AWMYJKDo/H9y8LAwAAH+k4EHkwH/yQPDwoDhAQAJzYcGLgIxcgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/EE.png
// module id = 1129
// module chunks = 0